<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="Payment Initiated" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="user_name" @keyup="searchUsers" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="clearSearch">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-4">
                                <b-table :items="subscriber_list" :fields="tablefields" :per-page="perPage" show-empty stacked="md">

                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(user_object)="row">
                                        <div style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.user?.first_name }} {{ row.item.user?.last_name }}</h7>
                                            <b-badge style="font-size: 13px; max-width: fit-content;">{{ row.item.user?.email }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(profile_id)="row">
                                        <h7 v-if="row.item.profile_id">{{ row.item.profile_id }}</h7>
                                    </template>

                                    <template #cell(phone_no)="row">
                                        <h7 v-if="row.item.phone_number">{{ row.item.phone_number }}</h7>
                                    </template>

                                    <template #cell(first_registration_date)="row">
                                        <h7 v-if="row.item.first_registration_date">{{ formatDate(row.item.first_registration_date).date }} <br> {{ formatDate(row.item.first_registration_date).time }}</h7>
                                    </template>

                                    <template #cell(unpaid_request.created_at)="row">
                                        <h7 v-if="row.item.unpaid_request?.created_at">{{ formatDate(row.item.unpaid_request?.created_at).date }} <br> {{ formatDate(row.item.unpaid_request?.created_at).time }}</h7>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <!-- <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col> -->
                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                <span>
                                    <!-- First Page Button (<<) -->
                                    <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                        <b-icon icon="chevron-double-left"></b-icon>
                                    </button>
    
                                    <!-- Previous Page Button (<) -->
    
                                    <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                        <b-icon icon="chevron-left"></b-icon>
                                    </button>
                                </span>

                                <!-- Page Number Display (Page X of Y) -->
                                <span class="align-self-center">
                                    <span class="align-self-center">
                                        <span class="d-flex align-items-center" style="gap: 6px;">
                                            <span>Page</span>
                                            <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                            <span>of {{ totalPages }}</span>
                                        </span>
                                    </span>
                                </span>

                                <span>
                                    <!-- Next Page Button (>) -->
                                    <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                        <b-icon icon="chevron-right"></b-icon>
                                    </button>
    
                                    <!-- Last Page Button (>>) -->
                                    <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                        <b-icon icon="chevron-double-right"></b-icon>
                                    </button>
                                </span>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            subscriber: {

            },
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user_object',
                    label: 'Subscriber',
                    sortable: false
                },
                {
                    key: 'phone_no',
                    label: 'Phone No',
                    sortable: false
                },
                {
                    key: 'profile_id',
                    label: 'Profile ID',
                    sortable: false
                },
                {
                    key: 'first_registration_date',
                    label: 'Registered On',
                    sortable: true
                },
                {
                    key: 'unpaid_request.created_at',
                    label: 'Initiated On',
                    sortable: true
                }
            ],

            initialLoad: true,
            filterShow: false,
            user_name: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            subscription_types: state => state.packages.package,
            subscriber_list: state => state.subscriber.payment_initiated,
            loading: state => state.subscriber.subscriberLoading,
            error: state => state.subscriber.subscriberError,
            count: state => state.subscriber.payment_initiated_count
        }),

        formattedSubscription() {
            return [{
                    value: null,
                    text: 'Select a subscription type',
                    disabled: true
                },
                ...this.subscription_types.map(type => ({
                    value: type.id,
                    text: type.title + " (" + type.type + ")"
                }))
            ];
        },

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                
                this.$router.replace({
                    path: '/subscription/payment-initiated/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });

                this.currentPage = newCurrentPage
                this.$store.dispatch("subscriber/fetchPaymentInitiated", {
                    user_name: this.user_name,
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/subscription/payment-initiated/list',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("subscriber/fetchPaymentInitiated", {
                    user_name: this.user_name,
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    created() {
        this.$store.dispatch("packages/fetchPackage")
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            const date = new Date(dateStr)

            const day = date.getDate()
            const month = date.toLocaleString('default', {
                month: 'long'
            })
            const year = date.getFullYear()

            const hours = date.getHours()
            const minutes = date.getMinutes().toString().padStart(2, '0')
            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${day}${getOrdinal(day)} ${month}, ${year}`,
                time: `${hour12}:${minutes} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("subscriber/fetchPaymentInitiated", {
                user_name: this.user_name,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        searchUsers() {
            if (this.user_name && this.user_name.trim() !== '' && this.user_name.length >= 2) {
                this.$store.dispatch("subscriber/fetchPaymentInitiated", {
                    user_name: this.user_name,
                    perPage: this.$route.query.perPage,
                    currentPage: this.$route.query.page
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        clearSearch() {
            this.user_name = null;
            this.fetchInitial();
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
</style>
